import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#00549d',
    primaryDark: '#004078',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/ohla-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/ohla-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/ohla-logo.png',

    availableProducts: ["Schadenmeldung", "Reparaturnachweis", "Haftpflichtschaden"],
});